import { useContext } from 'react';
import GroupAuthContext from 'src/contexts/GroupAuthContext';
import type { GroupAuthContextValue } from 'src/contexts/GroupAuthContext';

const useGroupAuth = (): GroupAuthContextValue => useContext(GroupAuthContext);

export default useGroupAuth;
